// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"style_progressBar__5splJ","percentage":"style_percentage__SfXPy"};